import { ReactElement } from 'react'
import styled from 'styled-components'

import { CONTACT_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { ImageTitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'

export const ContactPage = () => {
  return (
    <ContactMain>
      <ContactLinks>
        {CONTACT_ROUTE.subdirectories.map(
          ({ name, path, imagePath, ...other }) => (
            <LinkCard
              imgPath={imagePath}
              title={name}
              link={path}
              key={path}
              {...other}
            />
          )
        )}
      </ContactLinks>
    </ContactMain>
  )
}
ContactPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Inquiry', path: '' },
  ]

  return (
    <>
      <Head
        title="Inquiry"
        description="Inquiry for TRIAL Holdings, Inc."
        ogp={{ url: 'en/contact/' }}
      />
      <ImageTitleLayout
        title=""
        subTitle=""
        enTitle="Inquiry"
        imgUrl="/images/top-contact.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const ContactMain = styled.div`
  width: 1040px;
  margin: 96px auto 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px auto 80px;
    padding: 0 20px;
  }
`
const ContactLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 45px;
  img {
    width: 150px;
    height: 120px;
    object-fit: contain;
    transform: translate(20px);
  }

  @media screen and (max-width: 1047px) {
    justify-content: center;
    gap: 38px;
    img {
      height: 140px;
      object-fit: contain;
    }
  }
`
